import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1048fd48"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    img: null,
    url: null,
    active: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.url ? 'a' : 'button'), {
    href: __props.url,
    target: "_blank",
    class: _normalizeClass({
      [`w-24
      h-24
      md:w-44 md:h-44
      lg:w-52 lg:h-52
      rounded-full
      grid
      duration-200
      transition-opacity
      overflow-hidden
      focus:outline-none`]: true,
      'opacity-40 md:opacity-60': __props.active === false,
    })
  }, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        class: "col-start-1 row-start-1 w-full h-full object-cover overflow-hidden",
        alt: "",
        src: __props.img
      }, null, 8, _hoisted_1),
      _createElementVNode("span", {
        class: _normalizeClass({
        [`label
        col-start-1
        row-start-1
        w-full
        h-full
        min-w-0
        hidden
        md:flex
        justify-center
        items-center
        text-center
        font-bold
        transition-opacity
        duration-150
        bg-opacity-30 bg-black
        text-base
        md:text-xl
        lg:text-2xl
        p-1`]: true,
        'opacity-0': !__props.active,
      })
      }, _toDisplayString(__props.title), 3)
    ]),
    _: 1
  }, 8, ["href", "class"]))
}
}

})